import React from "react";
import { Route, Routes } from "react-router-dom";
import AnnouncementDetailScreen from "screens/App/CRM/Announcement/AnnouncementDetailScreen";
import AnnouncementListScreen from "screens/App/CRM/Announcement/AnnouncementListScreen";
import { VendorStaffDashboardScreen } from "screens/App/CRM/Dashboard/VendorStaffDashboardScreen";
import ShipmentReviewScreen from "screens/App/CRM/ShipmentRequest/ShipmentComponents/ShipmentReviewScreen";
import ShipmentDetailScreen from "screens/App/CRM/ShipmentRequest/ShipmentDetailScreen";
import ShipmentEditScreen from "screens/App/CRM/ShipmentRequest/ShipmentEditScreen";
import ShipmentListScreen from "screens/App/CRM/ShipmentRequest/ShipmentListScreen";
import ShipmentVendorCreateScreen from "screens/App/CRM/ShipmentRequest/ShipmentVendorCreateScreen";
import TicketCreateScreen from "screens/App/CRM/Ticket/TicketCreateScreen";
import TicketDetailScreen from "screens/App/CRM/Ticket/TicketDetailScreen";
import TicketEditScreen from "screens/App/CRM/Ticket/TicketEditScreen";
import TicketListScreen from "screens/App/CRM/Ticket/TicketListScreen";

export const VendorStaffSidebarRouter = () => {
  return (
    <Routes>
      <Route path="dashboard" element={<VendorStaffDashboardScreen />} />
      <Route path="shipment/create" element={<ShipmentVendorCreateScreen />} />
      <Route path="shipment/list" element={<ShipmentListScreen />} />
      <Route path="shipment/:id/edit" element={<ShipmentEditScreen />} />
      <Route path="shipment/:id/detail" element={<ShipmentDetailScreen />} />
      <Route path="ticket/list" element={<TicketListScreen />} />
      <Route path="ticket/create" element={<TicketCreateScreen />} />
      <Route path="ticket/:id/edit" element={<TicketEditScreen />} />
      <Route path="ticket/:id/detail" element={<TicketDetailScreen />} />
      <Route path="announcement/list" element={<AnnouncementListScreen />} />
      <Route
        path="staffBulkImport"
        element={<ShipmentReviewScreen />}
      />

      <Route
        path="announcement/:id/detail"
        element={<AnnouncementDetailScreen />}
      />
    </Routes>
  );
};
